import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Transaction_MainMenu } from "../../Connections/Transaction";

import "../../Styles/Menu.css";
import ModalCart from "../Alerts/ModalCart";
import BellNotification from "./BellNotification";

const Menu = () => {
  const location = useLocation();
  const navigator = useNavigate();
  const [inExam, setInExam] = useState("");
  useEffect(() => {
    setInExam(location.pathname.includes("/exam"));
  }, [location.pathname]);

  // ===============================================================
  const [bellNotificationIsOpen, setBellNotificationIsOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);

  // ===============================================================

  useEffect(() => {
    Transaction_MainMenu.Menu().then((res) => {
      if (res[1] == "ok") setMenuData(res[2]);
    });
  }, []);

  // ===============================================================

  const [modalCondition, setModalCondition] = useState(false);
  const [routeName, setRouteName] = useState("");

  const routeHandler = (itemLink) => {
    if (!inExam) {
      navigator(itemLink);
    } else {
      setModalCondition(true);
      setRouteName(itemLink);
    }
  };

  return (
    <div style={{ zIndex: 30 }} className="Menu_wrapper">
      <BellNotification
        isOpen={bellNotificationIsOpen}
        setIsOpen={setBellNotificationIsOpen}
      />
      <div className="Menu_inside">
        <ul className="Menu_ul">
          <div className="Menu_ul-li Menu_alerticon">
            <div className="Menu_ul-li-inside">
              <div
                className="Menu_ul-li-item-image"
                onClick={() =>
                  setBellNotificationIsOpen(!bellNotificationIsOpen)
                }
              >
                <img
                  className="Menu_ul-li-image"
                  src="/imgs/Menu/Alert.svg"
                  alt="alert"
                />
              </div>
              <div
                className="Menu_ul-li-item-image"
                style={{ marginRight: 20 }}
                onClick={() =>
                  navigator("/cart", {
                    state: {
                      prevPath: `${window.location.pathname}`,
                    },
                  })
                }
              >
                <img
                  className="Menu_ul-li-image"
                  src="/imgs/Menu/Shop.svg"
                  alt="alert"
                />
              </div>
            </div>
          </div>
          {menuData.map((item) => (
            <div
              onClick={() => routeHandler(item.link)}
              className="Menu_ul-li"
              key={item.id}
            >
              <div className="Menu_ul-li-inside">
                <div className="Menu_ul-li-item-image">
                  <div className="Menu_ul-li-image">
                    {item.icon(
                      location.pathname.includes(item.link) ? true : false
                    )}
                  </div>
                </div>

                <div className="Menu_ul-li-item-text">
                  <p
                    className={`Menu_ul-li-text ${
                      location.pathname.includes(item.link) ? "active" : ""
                    }`}
                  >
                    {item.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </ul>
      </div>
      <div className={`modal-wrapper ${!modalCondition && "hidden"}`}>
        <div className="ModalCart_box">
          <img src={"/imgs/cart/Asset.svg"} alt="icon image" />
          <h3 className="number-font">آیا میخواهید آزمون را ترک کنید ؟</h3>
          <h5 style={{ fontSize: "13px", color: "#000", lineHeight: "20px" }}>
            با خروج شما از آزمون ، این فرصت شما برای آزمون تمام میشود
          </h5>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="number-font"
              style={{
                borderRadius: "10px",
                backgroundColor: "rgb(204 18 18)",
                boxShadow: "none",
                color: "rgb(228 228 228)",
                marginLeft: "7px",
              }}
              onClick={() => {
                setModalCondition(false);
              }}
            >
              خیر
            </button>
            <button
              className="number-font"
              style={{
                borderRadius: "10px",
                backgroundColor: "rgb(73 153 73)",
                boxShadow: "none",
                color: "#fff",
                color: "rgb(228 228 228)",
              }}
              onClick={() => {
                navigator(routeName);
                setModalCondition(false);
              }}
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
